import(/* webpackMode: "eager" */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/deploy-artifact/src/app/(public)/[orgName]/page.tsx");
